var $ = require( 'jquery' );

$( document ).ready( function() {
});

